import es from './es.json'
import en from './en.json'

export const defaultLocale = 'es'

export const languages = {
    es,
    en,
}